import { render, staticRenderFns } from "./AddNewNotification.vue?vue&type=template&id=4330e9da&scoped=true"
import script from "./AddNewNotification.vue?vue&type=script&lang=js"
export * from "./AddNewNotification.vue?vue&type=script&lang=js"
import style0 from "./AddNewNotification.vue?vue&type=style&index=0&id=4330e9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330e9da",
  null
  
)

export default component.exports